<template>
<div class="user_order no-trans" v-loading="loading">
    <div class="order_titles">财务管理</div>
    <div class="user_order_box">
        <div class="order_types">
            <div class="lefts">
                <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" @click="handle_type(item)">
                    {{ item.title }}
                </div>
            </div>
            <div class="rights">
                <el-input
                    placeholder="输入订单号、产品名称"
                    v-model="keyword">
                </el-input>
                <div class="btns_input">导出</div>
            </div>
        </div>
        <div class="order_list">
            <el-table :data="order_list" style="width: 100%">          
                <el-table-column prop="order_sn" label="订单"></el-table-column>
                <el-table-column prop="product_title" label="产品名称"> </el-table-column>
                <el-table-column prop="username" label="会员"> </el-table-column>
                <el-table-column prop="created_at" label="收入时间"> </el-table-column>
                <el-table-column prop="yongjin" label="金额"> </el-table-column>
                
            </el-table>


        </div>
        <div class="pages_box">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.page"
                background
                :page-size="pages.limit"
                layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns"  @click="handle_pages(10)">尾页</div>
        </div>
    </div>
    
</div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:1,
            type_list:[
                {
                    title:'收入',
                    state:1,
                },
                {
                    title:'支出',
                    state:2,
                },
            ],
            order_list:[
               
            ],
            total:100,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state
            this.pages.page=1
            this.get_list()
        },
        handle_seach(){
            console.log('点击搜索')
        },
        handleSizeChange(e){
            console.log('条数',e)            
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.path.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()

        },
        get_list(){
            this.$api("yongjinList", {
                type:this.types_ac,
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('财务管理',res)
                if (res.code == 1) {
                    this.order_list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_deitial(){
            this.$router.push({
                path:'/user_dp/user_dp_detial',
                query:{

                }
            })
        },




    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                display: flex;
                align-items: center;
                /deep/.el-input{
                    width: 150px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 150px;
                        height: 32px;
                        font-weight: 400;
                        font-size: 12px;
                        color: #CCCCCC;

                    }
                    
                }
                .btns_input{
                    margin-left: 13px;
                    width: 72px;
                    height: 32px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    text-align: center;
                    line-height: 32px;
                    font-family: Source Han Sans SC, Source Han Sans SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;
                    cursor: pointer;
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list {
            margin-top: 29px;
            border: 1px solid #E5E5E5;
            /deep/.el-table{
                .el-table__header-wrapper{
                    .el-table__cell{
                        background-color: hsla(219, 98%, 60%, 0.03);
                        text-align: left !important;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        padding: 0 !important;
                        height: 44px;
                    }
                    .el-table__cell:nth-child(1){
                        padding-left: 24px !important;
                    }
                }
                .el-table__body-wrapper{
                    .el-table__row{
                        .el-table__cell{
                            text-align: left !important;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #333333;
                        }
                        .el-table__cell:nth-child(1){
                        padding-left: 24px !important;
                    }
                    }
                }
            }

           

        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_order.no-trans .user_order_box {
        padding: 16px 16px;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_order.no-trans .user_order_box .order_types {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types {
        font-size: 14px;
        padding-bottom: 12px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types_ac {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types .rights {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input {
        width: 150px;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__inner {
        width: 150px;
        height: 32px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types .rights .btns_input {
        margin-left: 13px;
        width: 72px;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
        line-height: 32px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_0 {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_0 img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_0 .texts {
        padding-top: 16px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list {
        margin-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_list /deep/ .el-table .el-table__header-wrapper .el-table__cell {
        font-size: 14px;
        padding: 0 !important;
        height: 44px;
    }
    .user_order.no-trans .user_order_box .order_list /deep/ .el-table .el-table__header-wrapper .el-table__cell:nth-child(1) {
        padding-left: 16px !important;
    }
    .user_order.no-trans .user_order_box .order_list /deep/ .el-table .el-table__body-wrapper .el-table__row .el-table__cell {
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .order_list /deep/ .el-table .el-table__body-wrapper .el-table__row .el-table__cell:nth-child(1) {
        padding-left: 16px !important;
    }
    .user_order.no-trans .user_order_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
